import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../Button';

interface UpdateProfileModalProps {
  /**
   * Determina se o modal está visível
   */
  isOpen: boolean;
  /**
   * Função chamada quando o modal é fechado
   */
  onClose: () => void;
  /**
   * Título do modal
   * @default "Atualização de Cadastro"
   */
  title?: string;
  /**
   * Mensagem principal do modal
   * @default "Por favor, atualize suas informações de cadastro para continuar utilizando a plataforma."
   */
  message?: string;
  /**
   * Texto do botão de atualização
   * @default "Atualizar Cadastro"
   */
  buttonText?: string;
  /**
   * Rota para redirecionamento
   * @default "/profile"
   */
  redirectPath?: string;
}

export const UpdateProfileModal: React.FC<UpdateProfileModalProps> = ({
  isOpen,
  onClose,
  title = 'Atualização de Cadastro',
  message = 'Por favor, complete seu cadastro para prosseguir com sua certificação. Informações atualizadas são necessárias para emissão do certificado.',
  buttonText = 'Atualizar Cadastro',
  redirectPath = '/profile',
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleRedirect = () => {
    onClose();
    navigate(redirectPath);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        />

        {/* Modal positioning trick */}
        <span
          className="hidden sm:inline-block sm:h-screen sm:align-middle"
          aria-hidden="true"
        >
          &#8203;
        </span>

        {/* Modal content */}
        <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                {/* Ícone de alerta/info */}
                <svg
                  className="h-6 w-6 text-blue-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  className="text-lg font-medium leading-6 text-gray-900"
                  id="modal-title"
                >
                  {title}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <Button
              onClick={handleRedirect}
              className="w-full sm:ml-3 sm:w-auto bg-[#000097] hover:bg-blue-800 text-white font-medium px-4 py-2 border-0 rounded-md shadow-sm"
            >
              {buttonText}
            </Button>
            <button
              type="button"
              className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
